import { fontSizes } from '@enechain/ecloud-designsystem'

/**
 * DS タブ (trigger) の文字サイズ — DS の実仕様 (lg = 16px) を利用箇所で明示する定数。
 *
 * DS の tabs recipe は base で `fontSize: 'lg'` を指定しているが、chakra 既定の
 * tabs recipe が持つ size variant (既定 = md → fontSize sm) が `createSystem` の
 * merge で base を上書きするため、明示しないとタブ文字が 12px (= eclair
 * fontSizes.sm) で描画される (2026-07-30 dev 実測: 生成 class に
 * `font-size: var(--chakra-font-sizes-sm)` が入る)。
 *
 * 12px は DS の実仕様 (`design/ui-feasibility/components/tabs.md`「trigger の font =
 * lg(16px)」) と design プロト実測 (16px) の双方と乖離しているため、タブの全利用箇所で
 * 本定数を渡して 16px に戻す。DS 側の recipe が size variant にも fontSize を持つよう
 * 修正されたら、本定数と各利用箇所の指定を削除する。
 */
export const tabTriggerFontSize = {
  /** chakra style prop 用の token 名 (raw slot の `<TabsTrigger fontSize={...}>`)。 */
  token: 'lg',
  /** DS `TabsComponent` の `tabSx` (= raw CSSProperties) 用の解決済み値。 */
  raw: fontSizes.lg.value,
} as const satisfies Record<string, string>
